export default __webpack_public_path__ + "static/media/025-pinocchio.6f59249a.svg";